import React, { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

const CsvList = () => {
  const [csvFiles, setCsvFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchCsvFiles = async () => {
      try {
        const response = await api.get("/api/csv");

        if (response.status === 200) {
          setCsvFiles(response.data.data);
        } else {
          setError("Failed to fetch CSV files");
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCsvFiles();
  }, []);

  const deleteCsvFile = async (csvFileId) => {
    setDeleting(csvFileId);
    try {
      const response = await api.delete(`/api/csv/${csvFileId}`);

      if (response.status === 204) {
        setCsvFiles(csvFiles.filter((csvFile) => csvFile.id !== csvFileId));
        setMessage("CSV file deleted successfully!");
        setTimeout(() => {
          setMessage("");
        }, 3000);
      } else {
        setError("Failed to delete CSV file");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setDeleting(null);
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  return (
    <div>
      {message && (
        <>
          <p style={{ color: "green" }}>{message}</p>
          <hr />
        </>
      )}

      <a href="/csv/upload" className="btn btn-primary">
        Upload a new CSV
      </a>
      <hr />
      <table className="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Upload Method</th>
            <th>File Path</th>
            <th>File URL</th>
            <th>Delimiter</th>
            <th>Update Interval</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {csvFiles.map((csvFile) => (
            <tr key={csvFile.id}>
              <td>{csvFile.id}</td>
              <td>{csvFile.name}</td>
              <td>{csvFile.upload_method}</td>
              <td>{csvFile.file_path}</td>
              <td>{csvFile.file_url}</td>
              <td>{csvFile.delimiter}</td>
              <td>{csvFile.update_interval}</td>
              <td>
                <a
                  style={{ color: "blue" }}
                  href={`/csv/edit/${csvFile.id}`}
                >
                  Edit
                </a>{" "}
                |{" "}
                <span
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={() => deleteCsvFile(csvFile.id)}
                >
                  {deleting === csvFile.id ? "Deleting..." : "Delete"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CsvList;